import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { SigningLink } from '@digital-platform/sign-now/domain';

interface Response<T> {
  signingLink: T;
}

@Injectable({
  providedIn: 'root',
})
export class SignaturesService {
  constructor(private httpClient: HttpClient) {}

  public getSignedDocLink(wasteProfileId: string): Observable<SigningLink> {
    return this.httpClient
      .get<Response<SigningLink>>(
        `/api/waste-profiles/signedDoc/${wasteProfileId}`
      )
      .pipe(map((response) => response.signingLink));
  }

  public getPdf(dataType: string, dataItemId: string): Observable<SigningLink> {
    return this.httpClient
      .get<SigningLink>(`api/sign-now/${dataType}/${dataItemId}/pdf`)
      .pipe(map((response) => response));
  }
}
